import { createSelector } from 'reselect';
import {
    departureCountryCodeSelector,
    arrivalCountryCodeSelector,
    localeSelector,
} from 'app/store/selectors';
import { userTypeSelector } from 'app/store/selectors/user';
import {
    getCountryPassengersByCountryCodes,
    getCharterPopupConfig,
    getPassengerCount,
    isCharterPopupActive,
} from 'app/functions/product';
import { StoreState } from 'app/models/types';
import { StoreProductField } from 'app/models/types/store/product';

// this includes products that are not active in the current Country-Country pair
export const allProductTypesSelector = (state: StoreState) => state.product.types;

export const currentProductTypesSelector = createSelector(
    allProductTypesSelector,
    departureCountryCodeSelector,
    arrivalCountryCodeSelector,
    userTypeSelector,
    (...args) => getCountryPassengersByCountryCodes(...args),
);

export const currentProductTypesExtendedSelector = createSelector(
    allProductTypesSelector,
    departureCountryCodeSelector,
    arrivalCountryCodeSelector,
    userTypeSelector,
    (...args) => getCountryPassengersByCountryCodes(...args, { extended: true }),
);

export const allProductsSelector = createSelector(
    currentProductTypesSelector,
    currentProductTypesExtendedSelector,
    (products, extendedProducts) => ({ ...products, ...extendedProducts }),
);

export const selectedProductsSelector = createSelector(
    allProductsSelector,
    products =>
        Object.values(products)
            .reduce((acc, curr) => {
                if (curr && curr.selectedAmount >= 1 || curr && curr.id === 'bike_slot') {
                    acc[curr.id] = curr;
                }
                return acc;
            }, {} as Partial<StoreProductField['types']>),
);

export const charterPopupConfigSelector = createSelector(
    localeSelector,
    (...args) => getCharterPopupConfig(...args),
);

export const passengerCountSelector = createSelector(
    allProductsSelector,
    getPassengerCount,
);

export const isCharterPopupActiveSelector = createSelector(
    passengerCountSelector,
    charterPopupConfigSelector,
    (...args) => isCharterPopupActive(...args),
);
